import logo from "./assets/arco-orbis2-logo.jpg";
import mikeRush from "./assets/mike-rush.jpg";
import frankShaw from "./assets/frank-shaw.jpg";

export { logo };

export const OWNERS = [
  {
    name: "Mike Rush",
    title: "Co-Founder & Owner",
    photo: mikeRush,
    email: "Mike.rush.arcoorbis2@proton.me",
    phone: "+971 50 413 0528",
    focus: ["Executive Protection", "Security Strategy", "International Movement", "Crisis Risk Management"],
    bio:
      "Mike Rush is a former British military professional and senior international security and risk management specialist with 20+ years' experience protecting UHNWIs, executives, diplomatic missions and family offices worldwide. Specialising in executive protection, security strategy, international movement coordination and crisis risk management, Mike delivers discreet, intelligence-led solutions across high-risk and complex global environments.",
  },
  {
    name: "Frank Shaw",
    title: "Co-Founder & Owner",
    photo: frankShaw,
    email: "Frank.shaw.arcoorbis2@proton.me",
    phone: "+971 50 386 5762",
    focus: ["Strategic Security Risk", "Governance & Continuity", "Supply Chain De-Risking", "Stakeholder Alignment"],
    bio:
      "A British Army veteran with 20+ years of experience in stakeholder management and high-stakes operational risk, Frank specialises in strategic Security Risk Management. He translates complex threat intelligence into actionable governance and continuity strategies — de-risking supply chains, streamlining stakeholder alignment, and pre-empting mission-critical failures before they materialise. His value lies in providing leadership with the analytical foresight to navigate volatile environments without physical intervention.",
  },
];

// ============================================================================
//  CENTRAL BUSINESS CONFIGURATION
//  Edit these values to update contact details across the whole site.
//  BUSINESS_EMAILS and BUSINESS_PHONES accept one OR many entries.
//  Leave a value / array empty to hide it everywhere automatically.
// ============================================================================
export const SITE = {
  BUSINESS_EMAILS: ["Mike.rush.arcoorbis2@proton.me", "Frank.shaw.arcoorbis2@proton.me"],
  BUSINESS_PHONES: ["+971 50 413 0528", "+971 50 386 5762"],
  BUSINESS_ADDRESS:
    "Ras Al Khaimah Economic Zone Authority (RAKEZ), Al Nakheel Area, PO Box 10055, Ras Al Khaimah, UAE",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Meet Us", to: "/meet-us" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_CATEGORIES = [
  {
    slug: "bespoke-security",
    label: "Bespoke Security",
    tagline: "Security advice that actually fits.",
    intro: "No two clients are the same, so we don't pretend they are. We take the time to understand your people, your buildings and your day-to-day reality — then give you clear, practical security advice you can genuinely use.",
    items: [
      { title: "Security Consultancy", desc: "Professional security consultancy designed around the individual requirements of clients, organisations, buildings and facilities." },
      { title: "Threat & Vulnerability Assessment", desc: "Bespoke assessment of relevant security threats, vulnerabilities and exposure, with professional recommendations to help reduce risk." },
      { title: "Security Governance, SOPs & Compliance", desc: "Advisory support around governance frameworks, Standard Operating Procedures, policies, roles and compliance alignment." },
      { title: "Building & Facility Security", desc: "Security consultancy for buildings and facilities — requirements, systems, technical solutions and design considerations." },
      { title: "Security Master Planning", desc: "Strategic security master planning bringing together risk, physical and technical security, operations and design." },
      { title: "Insider Threat & Due Diligence", desc: "Careful, professional advisory on insider-threat considerations, personnel risk, access, governance and due diligence." },
    ],
  },
  {
    slug: "risk-management",
    label: "Risk Management",
    tagline: "Identify, analyse and reduce risk.",
    intro: "Structured risk management that helps you understand threats and vulnerabilities, prepare for disruption, and respond with confidence.",
    process: ["Identify", "Analyse", "Prioritise", "Mitigate", "Review"],
    items: [
      { title: "Risk Analysis & Mitigation", desc: "Structured analysis of identified risks and the development of appropriate, prioritised mitigation strategies." },
      { title: "Crisis Management Planning", desc: "Bespoke crisis management planning to help organisations prepare for and respond to potential crisis situations." },
      { title: "Incident Response & Threat Readiness", desc: "Tabletop exercises and structured readiness assessments that strengthen organisational and team preparedness." },
    ],
  },
  {
    slug: "technical-solutions",
    label: "Technical Solutions",
    tagline: "Where the physical and technical meet.",
    intro: "Locks, cameras, systems and networks only really work when they work together. We make sense of the technical side of security and set out solutions that match how your site and your people actually operate.",
    items: [
      { title: "Cyber-Physical Security Alignment", desc: "Advisory bridging physical security systems and technical / cyber-related security considerations — access control, infrastructure and integration." },
      { title: "Security & Technical Solutions", desc: "Appropriate security and technical solutions set out based on the requirements of a building, facility or organisation." },
      { title: "Technical Specifications", desc: "Advisory relating to the design, development and layout of technical specifications." },
    ],
  },
  {
    slug: "travel-risk-management",
    label: "Travel Risk Management",
    tagline: "Travel with your eyes open.",
    intro: "Every trip carries its own risks, and a plan built for one journey rarely fits the next. We build travel advice around the specific person, place and purpose — so you can focus on why you're going, not what might go wrong.",
    process: ["Assess", "Plan", "Advise", "Review"],
    items: [
      { title: "Travel Risk Assessment", desc: "Bespoke assessment of the risks relevant to a journey, destination, individual or organisation." },
      { title: "Destination & Journey Planning", desc: "Destination considerations and journey planning shaped around the specific circumstances of the trip." },
      { title: "Mitigation & Traveller Awareness", desc: "Risk identification, mitigation planning and traveller awareness to support safer travel." },
      { title: "Review", desc: "Review of plans and considerations as circumstances and destinations change." },
    ],
    note: "Advisory and planning only. Arco Orbis2 does not claim armed protection, transportation, evacuation or other operational services unless specifically provided.",
  },
  {
    slug: "wider-risk-management",
    label: "Wider Risk Management",
    tagline: "Resilience, from every angle.",
    intro: "Threats rarely arrive one at a time. We take a joined-up look at everything from your supply chain to the people inside your organisation, helping you build the kind of resilience that holds up when it's tested.",
    items: [
      { title: "Threat Assessment", desc: "Understanding the relevant threats facing your people, organisation or environment." },
      { title: "Vulnerability Assessment", desc: "Identifying vulnerabilities and points of exposure across your operations." },
      { title: "Risk Analysis", desc: "Evaluating likelihood and potential consequence to prioritise what matters most." },
      { title: "Mitigation Strategies", desc: "Developing appropriate, proportionate strategies to reduce identified risk." },
      { title: "Supply Chain Vulnerability Mapping", desc: "Understanding vulnerabilities across your supply chain: supplier, dependency, exposure, vulnerability and mitigation." },
      { title: "Crisis & Incident Readiness", desc: "Preparedness, response planning and readiness exercises to strengthen resilience." },
    ],
  },
  {
    slug: "strategic-deliverables",
    label: "Strategic Deliverables",
    tagline: "The paperwork that earns its place.",
    intro: "Good security work should leave you with something useful in your hands. These are the practical documents we can build with you — clear, structured, and written to be used, not filed away and forgotten.",
    items: [
      { title: "Security Risk Registers & Threat Matrices", desc: "Structured documentation of identified risks, threats, vulnerabilities, priorities and mitigation considerations." },
      { title: "Concept of Security (ConOps) Documents", desc: "Clearly structured security concepts setting out the intended approach, requirements and considerations." },
      { title: "Security Design Criteria & Technical Specifications", desc: "Professional documentation setting out security design requirements and technical considerations." },
      { title: "Crisis Management & Emergency Response Manuals", desc: "Structured planning documents supporting organisational crisis preparedness and response." },
      { title: "Vendor Compliance & Standard Operating Procedures (SOPs)", desc: "Documentation supporting vendor requirements, security governance, operating procedures and compliance alignment." },
    ],
    note: "Presented as potential strategic outputs developed according to client requirements.",
  },
];

export const SERVICES = [
  {
    title: "Security Threat & Vulnerability Assessment",
    summary:
      "Bespoke assessment of relevant security threats, vulnerabilities and exposure — understanding your environment and providing professional recommendations to reduce risk.",
    points: ["Environment analysis", "Vulnerability identification", "Exposure mapping", "Professional recommendations"],
  },
  {
    title: "Risk Analysis & Mitigation Strategies",
    summary:
      "Structured analysis of identified risks and the development of appropriate mitigation strategies tailored to your priorities.",
    process: ["Identify", "Analyse", "Prioritise", "Mitigate", "Review"],
  },
  {
    title: "Security Consultancy",
    summary:
      "Professional security consultancy designed around the individual requirements of clients, organisations, buildings and facilities.",
    points: ["Client-led approach", "Considered advice", "Bespoke solutions"],
  },
  {
    title: "Security Governance, SOPs & Compliance Alignment",
    summary: "Advisory support around governance frameworks, procedures, policies and compliance alignment.",
    points: ["Governance frameworks", "Standard Operating Procedures", "Security policies", "Roles & responsibilities", "Compliance alignment", "Governance structures", "Security processes"],
  },
  {
    title: "Travel Risk Management",
    summary:
      "Bespoke travel risk assessments and management plans designed around the specific circumstances of a journey, destination, individual or organisation.",
    points: ["Travel risk assessment", "Destination considerations", "Journey planning", "Risk identification", "Mitigation planning", "Traveller awareness", "Review"],
  },
  {
    title: "Crisis Management Planning",
    summary: "Bespoke crisis management planning to help organisations prepare for and respond to potential crisis situations.",
    points: ["Crisis preparedness", "Risk identification", "Response planning", "Roles & responsibilities", "Escalation considerations", "Decision-making", "Recovery & review"],
  },
  {
    title: "Supply Chain Vulnerability Mapping",
    summary: "Advisory services helping organisations understand vulnerabilities across their supply chain.",
    process: ["Supplier", "Dependency", "Exposure", "Vulnerability", "Mitigation"],
  },
  {
    title: "Security Master Planning",
    summary: "Strategic security master planning for organisations, buildings, facilities and wider environments.",
    points: ["Security requirements", "Risk considerations", "Physical security", "Technical security", "Operational requirements", "Future development", "Design considerations"],
  },
  {
    title: "Cyber-Physical Security Alignment",
    summary: "Advisory services bridging physical security and cyber/technical security considerations.",
    points: ["Physical security systems", "Technical security systems", "Security technology", "Access control", "Security infrastructure", "System integration", "Cyber-physical alignment"],
  },
  {
    title: "Incident Response & Threat Readiness Tabletop Exercises",
    summary: "Consultancy around incident response and threat-readiness exercises to strengthen organisational preparedness and team readiness.",
    process: ["Scenario", "Exercise", "Evaluate", "Lessons Learned", "Improve"],
  },
  {
    title: "Insider Threat & Due Diligence Advisory",
    summary: "Advisory services relating to insider-threat considerations and due diligence, using careful professional language.",
    points: ["Insider-threat exposure", "Personnel-related risk", "Due diligence processes", "Access considerations", "Risk indicators", "Governance", "Mitigation strategies"],
  },
  {
    title: "Building & Facility Security",
    summary: "Security consultancy for buildings and facilities, integrating requirements, systems and design considerations.",
    points: ["Security requirements", "Building safety", "Facility protection", "Security systems", "Technical solutions", "Design considerations", "Layout & planning"],
  },
  {
    title: "Security & Technical Solutions",
    summary: "Appropriate security and technical solutions set out based on the requirements of a building, facility or organisation.",
    points: ["Requirement-led solutions", "Technical integration", "Considered design"],
  },
  {
    title: "Technical Specifications",
    summary: "Advisory services relating to the design, development and layout of technical specifications.",
    points: ["Specification design", "Development support", "Layout & structure"],
  },
];

export const RISK_CARDS = [
  "Threat Assessment", "Vulnerability Assessment", "Risk Analysis", "Mitigation Strategies",
  "Crisis Planning", "Travel Risk", "Supply Chain Risk", "Insider Threat", "Incident Readiness",
];

export const DELIVERABLES = [
  { code: "DOC-01", title: "Security Risk Registers & Threat Matrices", desc: "Structured documentation of identified risks, threats, vulnerabilities, priorities and mitigation considerations." },
  { code: "DOC-02", title: "Concept of Security (ConOps) Documents", desc: "Clearly structured security concepts setting out the intended approach, requirements and considerations." },
  { code: "DOC-03", title: "Security Design Criteria & Technical Specifications", desc: "Professional documentation setting out security design requirements and technical considerations." },
  { code: "DOC-04", title: "Crisis Management & Emergency Response Manuals", desc: "Structured planning documents supporting organisational crisis preparedness and response." },
  { code: "DOC-05", title: "Vendor Compliance & Standard Operating Procedures", desc: "Documentation supporting vendor requirements, security governance, operating procedures and compliance alignment." },
];

export const APPROACH = [
  { n: "01", title: "Understand", desc: "Understand the client's requirements, environment and objectives." },
  { n: "02", title: "Assess", desc: "Consider relevant security, travel, crisis, technical and operational risks." },
  { n: "03", title: "Analyse", desc: "Evaluate threats, vulnerabilities, dependencies and potential consequences." },
  { n: "04", title: "Develop", desc: "Develop a bespoke strategy, plan or solution." },
  { n: "05", title: "Advise", desc: "Provide professional advice and clearly defined recommendations." },
  { n: "06", title: "Deliver", desc: "Produce appropriate strategic documentation, plans, specifications or advisory outputs." },
  { n: "07", title: "Review", desc: "Review effectiveness, readiness and changing risk considerations where required." },
];

export const WHY = [
  { title: "Bespoke", desc: "Solutions designed around individual requirements." },
  { title: "Professional", desc: "A structured and consultancy-led approach." },
  { title: "Strategic", desc: "Consider immediate requirements alongside wider risk considerations." },
  { title: "Risk-Focused", desc: "Identify threats, vulnerabilities and potential exposure." },
  { title: "Technical", desc: "Security and technical considerations integrated into the planning process." },
  { title: "Resilient", desc: "Support stronger preparedness, response and organisational readiness." },
  { title: "Global", desc: "A strong international identity reflected by the company's global focus." },
  { title: "Practical", desc: "Clear advice, strategies and deliverables designed to be useful and actionable." },
];

export const SERVICE_OPTIONS = [
  "Security Consultancy", "Threat & Vulnerability Assessment", "Risk Analysis & Mitigation",
  "Security Governance & SOPs", "Travel Risk Management", "Crisis Management Planning",
  "Supply Chain Vulnerability Mapping", "Security Master Planning", "Cyber-Physical Security Alignment",
  "Incident Response & Tabletop Exercises", "Insider Threat & Due Diligence", "Building & Facility Security",
  "Security & Technical Solutions", "Technical Specifications", "Other",
];
